document.addEventListener('DOMContentLoaded', () => {
  const rail = document.querySelector('#generation-rail');
  const previous = document.querySelector('.generation-scroll-prev');
  const next = document.querySelector('.generation-scroll-next');

  const scrollAmount = () => {
    const card = rail?.querySelector('.product-card:not(.is-hidden)');
    const gap = Number.parseFloat(getComputedStyle(rail).gap) || 20;
    return card ? card.getBoundingClientRect().width + gap : rail.clientWidth;
  };
  const updateControls = () => {
    if (!rail || !previous || !next) return;
    previous.disabled = rail.scrollLeft <= 4;
    next.disabled = rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 4;
  };

  if (rail && previous && next) {
    previous.addEventListener('click', () => rail.scrollBy({left:-scrollAmount(),behavior:'smooth'}));
    next.addEventListener('click', () => rail.scrollBy({left:scrollAmount(),behavior:'smooth'}));
    rail.addEventListener('scroll', updateControls, {passive:true});
    window.addEventListener('resize', updateControls);
    updateControls();
  }

  document.querySelectorAll('.generation-tabs .tab').forEach((tab) => {
    tab.addEventListener('click', () => {
      document.querySelectorAll('.generation-tabs .tab').forEach((item) => {
        const active = item === tab;
        item.classList.toggle('active', active);
        item.setAttribute('aria-selected', String(active));
      });
      rail?.querySelectorAll('.product-card').forEach((card) => {
        card.classList.toggle('is-hidden', tab.dataset.filter !== 'all' && card.dataset.tags !== tab.dataset.filter);
      });
      rail?.scrollTo({left:0, behavior:'smooth'});
      requestAnimationFrame(updateControls);
    });
  });

  const trustpilotWidget = document.querySelector('footer .trustpilot-widget');
  const callToAction = document.querySelector('.cta-content');
  if (trustpilotWidget && callToAction) {
    trustpilotWidget.classList.add('wth-trustpilot-cta');
    callToAction.appendChild(trustpilotWidget);
  }
});
